import { apiRequest, getApiUrl } from '../../config/api';

// Cliente de /api/bots/{botId}/contactos. Ninguna función lanza: devuelven
// { ok, status, data } y, si la red falla, un 0 con un detail legible.

const SIN_RED = { ok: false, status: 0, data: { detail: 'Error de conexión con el servidor.' } };

export const TAMANO_PAGINA = 20;

const json = async (ruta, opciones) => {
  try {
    const res = await apiRequest(getApiUrl(ruta), opciones);
    return { ok: res.ok, status: res.status, data: await res.json().catch(() => ({})) };
  } catch (e) {
    return SIN_RED;
  }
};

export const listarContactos = (botId, { page = 0, soloClientes = false, q = '' } = {}) =>
  json(
    `/bots/${botId}/contactos?page=${page}&size=${TAMANO_PAGINA}&soloClientes=${soloClientes}` +
      (q ? `&q=${encodeURIComponent(q)}` : ''),
  );

export const obtenerContacto = (botId, chatId) => json(`/bots/${botId}/contactos/${chatId}`);

export const cambiarCliente = (botId, chatId, cliente) =>
  json(`/bots/${botId}/contactos/${chatId}/cliente`, {
    method: 'PUT',
    body: JSON.stringify({ cliente }),
  });

export const listarRegistros = (botId, chatId, page = 0) =>
  json(`/bots/${botId}/contactos/${chatId}/registros?page=${page}&size=${TAMANO_PAGINA}`);
